import {
  SalesforceAccountProductBundle,
  SalesforceAccountStatus,
} from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';

export const SalesforceAccountStatusValue: Record<SalesforceAccountStatus, string> = {
  UNKNOWN_SALESFORCE_ACCOUNT_STATUS: 'Unknown',
  ACCOUNT_STATUS_ACTIVE: 'Active',
  ACCOUNT_STATUS_SALES_PROCESS: 'Sales Process',
  ACCOUNT_STATUS_ONBOARDING: 'Onboarding',
  ACCOUNT_STATUS_ONBOARDING_ACTIVE: 'Onboarding (Active)',
  ACCOUNT_STATUS_CANCELED: 'Canceled',
  ACCOUNT_STATUS_LOST: 'Lost',
  ACCOUNT_STATUS_GENERAL_BUSINESS_CONTACTS: 'General Business Contacts',
};

export const SalesforceAccountProductBundleValue = {
  UNKNOWN_SALESFORCE_ACCOUNT_PRODUCT_BUNDLE: 'Unknown',
  PRODUCT_BUNDLE_WEAVE_LITE: 'WeaveLite',
  PRODUCT_BUNDLE_WEAVE_CORE: 'WeaveCore',
  PRODUCT_BUNDLE_WEAVE_PLUS: 'WeavePlus',
  PRODUCT_BUNDLE_ATTRACT: 'Attract',
  PRODUCT_BUNDLE_COMMUNICATE: 'Communicate',
  PRODUCT_BUNDLE_COMMUNICATE_ATTRACT: 'Communicate - Attract',
  PRODUCT_BUNDLE_COMMUNICATE_CONTACT_SYNC: 'Communicate + Contact Sync',
  PRODUCT_BUNDLE_COMMUNICATE_ENGAGE: 'Communicate - Engage',
  PRODUCT_BUNDLE_COMMUNICATE_ENGAGE_ATTRACT: 'Communicate - Engage - Attract',
  PRODUCT_BUNDLE_DIGITAL_FORMS: 'Digital Forms',
  PRODUCT_BUNDLE_ENGAGE_ATTRACT: 'Engage - Attract',
  PRODUCT_BUNDLE_ENGAGE: 'Engage',
  PRODUCT_BUNDLE_FEATURE_SPECIFIC: 'Feature Specific',
  PRODUCT_BUNDLE_NUMBER_SERVING: 'Number Servicing Only',
  PRODUCT_BUNDLE_PHONE_NUMBER_SERVICING: 'Phone Number Servicing',
  PRODUCT_BUNDLE_PHONE_SERVICE_ONLY: 'Phone Service Only',
  PRODUCT_BUNDLE_TEXT_MESSAGE_SERVICE: 'Text Message Service',
  PRODUCT_BUNDLE_UNIFY_ATTRACT: 'Unify - Attract',
  PRODUCT_BUNDLE_UNIFY_COMMUNICATE: 'Unify - Communicate',
  PRODUCT_BUNDLE_UNIFY_COMMUNICATE_ATTRACT: 'Unify - Communicate - Attract',
  PRODUCT_BUNDLE_UNIFY_COMMUNICATE_ENGAGE_ATTRACT: 'Unify - Communicate - Engage - Attract',
  PRODUCT_BUNDLE_UNIFY_COMMUNICATE_ENGAGE: 'Unify - Communicate - Engage',
  PRODUCT_BUNDLE_UNIFY_ENGAGE_ATTRACT: 'Unify - Engage - Attract',
  PRODUCT_BUNDLE_UNIFY_ENGAGE: 'Unify - Engage',
  PRODUCT_BUNDLE_UNIFY_WEAVE_SOFTWARE_PHONES: 'Unify Weave Software w/Plus phones',
  PRODUCT_BUNDLE_WEAVE_CORE_CONTACT_SYNC_DSA_SOFTWARE_ONLY: 'Weave Core + Contact Sync DSA Software Only',
  PRODUCT_BUNDLE_WEAVE_CORE_CONTACT_SYNC_DSA_STARTER_PROMO: 'Weave Core + Contact Sync DSA Starter Promo',
  PRODUCT_BUNDLE_WEAVE_CORE_CONTACT_SYNC_DSA: 'Weave Core Contact Sync DSA',
  PRODUCT_BUNDLE_WEAVE_UNIFY_CORE_SOFTWARE_ONLY: 'Weave Unify Core Software Only',
  PRODUCT_BUNDLE_WEAVE_UNIFY_CORE: 'Weave Unify Core',
  PRODUCT_BUNDLE_WEAVE_UNIFY_PLUS_SOFTWARE_ONLY: 'Weave Unify Plus Software Only',
  PRODUCT_BUNDLE_WEAVE_UNIFY_PLUS: 'Weave Unify Plus',
  PRODUCT_BUNDLE_WEAVE_CORE_SOFTWARE_ONLY: 'WeaveCore (Software Only)',
  PRODUCT_BUNDLE_WEAVE_CORE_SOFTWARE_ONLY_NO_PREMIUM_FEATURES: 'WeaveCore Software Only : No Premium Features',
  PRODUCT_BUNDLE_WEAVE_CORE_STARTER_PROMO: 'WeaveCore Starter Promo',
  PRODUCT_BUNDLE_WEAVE_CORE_NO_PREMIUM: 'WeaveCore : No Premium Features',
  PRODUCT_BUNDLE_WEAVEPLUS_AND_DENTRIX: 'WeavePlus & Dentrix',
  PRODUCT_BUNDLE_WEAVE_PLUS_AND_OPEN_DENTAL: 'WeavePlus & Open Dental',
  PRODUCT_BUNDLE_WEAVE_PLUS_SOFTWARE_ONLY: 'WeavePlus (Software Only)',
  PRODUCT_BUNDLE_WEAVE_PLUS_ENHANCED: 'WeavePlus Enhanced',
  PRODUCT_BUNDLE_WEAVE_PLUS_ENHANCED_NO_PREMIUM: 'WeavePlus Enhanced : No Premium Features',
  PRODUCT_BUNDLE_WEAVE_PLUS_SOFTWARE_ONLY_NO_PREMIUM: 'WeavePlus Software Only : No Premium Features',
  PRODUCT_BUNDLE_WEAVE_PLUS_STARTER_PROMO: 'WeavePlus Starter Promo',
  PRODUCT_BUNDLE_WEAVE_PLUS_NO_PREMIUM: 'WeavePlus : No Premium Features',
  PRODUCT_BUNDLE_WEAVE_PLUS_PRO: 'WeavePlus - Pro',
  PRODUCT_BUNDLE_WEAVE_CORE_PRO: 'WeaveCore - Pro',
  PRODUCT_BUNDLE_WEAVE_PLUS_ELITE: 'WeavePlus - Elite',
  PRODUCT_BUNDLE_WEAVE_CORE_ELITE: 'WeaveCore - Elite',
  PRODUCT_BUNDLE_WEAVE_PLUS_ESSENTIALS: 'WeavePlus - Essentials',
  PRODUCT_BUNDLE_WEAVE_CORE_ESSENTIALS: 'WeaveCore - Essentials',
  PRODUCT_BUNDLE_WEAVE_CORE_SOFTWARE_ONLY_ESSENTIALS: 'WeaveCore Software Only - Essentials',
  PRODUCT_BUNDLE_WEAVE_CORE_SOFTWARE_ONLY_PRO: 'WeaveCore Software Only - Pro',
  PRODUCT_BUNDLE_WEAVE_CORE_SOFTWARE_ONLY_ELITE: 'WeaveCore Software Only - Elite',
  PRODUCT_BUNDLE_WEAVE_PLUS_SOFTWARE_ONLY_ESSENTIALS: 'WeavePlus Software Only - Essentials',
  PRODUCT_BUNDLE_WEAVE_PLUS_SOFTWARE_ONLY_PRO: 'WeavePlus Software Only - Pro',
  PRODUCT_BUNDLE_WEAVE_PLUS_SOFTWARE_ONLY_ELITE: 'WeavePlus Software Only - Elite',
  PRODUCT_BUNDLE_PATTERSON: 'Patterson',
  PRODUCT_BUNDLE_PATTERSON_SOFTWARE_ONLY: 'Patterson Software Only',
  PRODUCT_BUNDLE_WEAVE_PLUS_ULTIMATE: 'WeavePlus - Ultimate',
  PRODUCT_BUNDLE_WEAVE_CORE_ULTIMATE: 'WeaveCore - Ultimate',
  PRODUCT_BUNDLE_WEAVE_PLUS_SOFTWARE_ONLY_ULTIMATE: 'WeavePlus Software Only - Ultimate',
  PRODUCT_BUNDLE_WEAVE_CORE_SOFTWARE_ONLY_ULTIMATE: 'WeaveCore Software Only - Ultimate',
  PRODUCT_BUNDLE_WEAVE_PLUS_ESSENTIALS_WITH_PAYMENT_TERMINAL: 'Payments Bundle - Essentials',
  PRODUCT_BUNDLE_WEAVE_PLUS_PRO_WITH_PAYMENT_TERMINAL: 'Payments Bundle - Pro',
  PRODUCT_BUNDLE_WEAVE_PLUS_ELITE_WITH_PAYMENT_TERMINAL: 'Payments Bundle - Elite',
  PRODUCT_BUNDLE_WEAVE_PLUS_ULTIMATE_WITH_PAYMENT_TERMINAL: 'Payments Bundle - Ultimate',
  //TODO: add these
  PRODUCT_BUNDLE_WV_TR: 'Unknown',
  PRODUCT_BUNDLE_SPR: 'Unknown',
  PRODUCT_BUNDLE_WV_PSM: 'Unknown',
  PRODUCT_BUNDLE_PSS: 'Unknown',
  PRODUCT_BUNDLE_WV_SRM: 'Unknown',
} satisfies Record<SalesforceAccountProductBundle, string>;

export const OfficeTypeValue: Record<string, string> = {
  0: 'Unknown',
  1: 'Single',
  2: 'DataBeta',
  3: 'UnifyChild',
  4: 'UnifyParent',
};
